/**
 * Central GSAP entry point.
 *
 * Import gsap and its plugins from this module everywhere in the app:
 *
 *   import { gsap, ScrollTrigger, useGSAP } from '@utils/gsap'
 *
 * Plugins are registered exactly once, here, at import time — so any module
 * that pulls gsap from this file is guaranteed to have ScrollTrigger,
 * TextPlugin, CustomEase and the useGSAP hook available. Do not import from
 * 'gsap', 'gsap/all' or the individual plugin paths elsewhere, and do not
 * call gsap.registerPlugin in other files.
 */
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { TextPlugin } from 'gsap/TextPlugin'
import { CustomEase } from 'gsap/CustomEase'
import { useGSAP } from '@gsap/react'

gsap.registerPlugin(useGSAP, ScrollTrigger, TextPlugin, CustomEase)

export { gsap, ScrollTrigger, TextPlugin, CustomEase, useGSAP }
